import { Button } from '@practium/ui';
import styles from './MixturesPanel.module.css';

interface MixtureReviewFooterProps {
	total: number;
	pendingCount: number;
	isFiltered: boolean;
	isPending: boolean;
	onConfirmAll: () => void;
}

const footerMessage = (total: number, pendingCount: number, isFiltered: boolean) => {
	if (pendingCount === 0) {
		return isFiltered
			? 'As aplicações filtradas já foram conferidas.'
			: `As ${total} aplicações já foram conferidas. Clique para salvar o planejamento.`;
	}
	const isSingle = pendingCount === 1;
	const noun = isSingle ? 'aplicação' : 'aplicações';
	const filtered = isSingle ? ' filtrada' : ' filtradas';
	const subject = isFiltered ? `${noun}${filtered}` : noun;
	const verb = isSingle ? 'ainda precisa' : 'ainda precisam';
	return `${pendingCount} ${subject} ${verb} da sua conferência.`;
};

export const MixtureReviewFooter = ({
	total,
	pendingCount,
	isFiltered,
	isPending,
	onConfirmAll,
}: MixtureReviewFooterProps) => (
	<div className={styles.workspaceFooter}>
		<p className={styles.footerText}>{footerMessage(total, pendingCount, isFiltered)}</p>
		<Button
			variant="primary"
			onClick={onConfirmAll}
			disabled={pendingCount === 0}
			isLoading={isPending}
			className={styles.confirmAll}
		>
			{isFiltered ? `Confirmar filtradas (${pendingCount})` : 'Confirmar Todas'}
		</Button>
	</div>
);
